import { useMemo } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import type { PsfSharePageData } from '#src/app/pages/psf/share/pageContext';

type ConstituentPsfExperiment = PsfSharePageData['experiments']['constituentPsfExperiment'];

type Result = {
	/** Raw resolved experiment, for deferred treatment + exposure. */
	experiment: ConstituentPsfExperiment;
	/** The assigned arm: 'control' | 'v2_new_share' | 'v4_new_goal' (plus any unrecognized string served as control). */
	variation: ConstituentPsfExperiment['variation'];
};

/**
 * Passthrough for the Constituents-in-PSF experiment resolved on the share page. Fetched with
 * `treat: false`; treatment + exposure are deferred to the client via `useTreatConstituentPsfExperiment`
 * once the signer is confirmed an identified constituent (sessionStorage, client-only state the
 * experiment service can't target on).
 */
export function useConstituentPsfExperiment(): Result {
	const {
		data: {
			experiments: { constituentPsfExperiment: experiment },
		},
	} = usePsfSharePageData();

	return useMemo(() => ({ experiment, variation: experiment.variation }), [experiment]);
}
